<template>
	<ui-modal v-on:close="$emit('close')">
		<template v-slot:header>
			<div class="bg-green-500 px-6 py-4 text-white">
				<h1 class="text-4xl font-bold" v-if="acl.needs_complete_profile">
					<span v-if="locale == 'de'">{{
						__("Stammdaten nicht vollständig")
					}}</span>
					<span v-else>{{ __("Data not complete") }}</span>
				</h1>

				<h1 class="text-4xl font-bold" v-else>{{ __("Almost done!") }}</h1>
			</div>
		</template>

		<template v-slot:full-content>
			<content-start-modal-needs-complete-profile
				v-if="acl.needs_complete_profile"
			/>
			<content-start-modal-not-yet-activated v-else />
		</template>

		<template v-slot:buttons>
			<div class="bg-gray-100 text-lg sm:text-base px-6 pb-6 pt-4 text-right">
				<ui-button
					v-if="acl.needs_complete_profile"
					type="primary"
					class="whitespace-nowrap"
					v-on:click="continueToCompleteProfile()"
					>{{ __("Continue") }}</ui-button
				>

				<ui-button
					v-else
					type="primary"
					class="whitespace-nowrap"
					v-on:click="$emit('close')"
					>{{ __("Close") }}</ui-button
				>
			</div>
		</template>
	</ui-modal>
</template>

<script>
export default {
	data() {
		return {
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {
		continueToCompleteProfile() {
			this.$bus.$emit(
				"toggle-iframe-modal",
				this.$route("user.complete_profile", { iframe_modal: true })
			);
			this.$emit("close");
		},
	},
};
</script>
